<template>
  <div class="cet-text">
    <h1>404</h1>
    <h2>Page Not Found</h2>
  </div>

</template>

<script>

export default {
  name: 'NotFound'
}
</script>

<style scoped>
.cet-text {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
